import { endOfDay, format, startOfDay, sub } from 'date-fns'

import {
  CalendarRange,
  PERIOD_MAP,
  PeriodValues
} from '@/components-latest/ui/PerformancePage/DateRangeSelect/DateRangeSelect'
import i18n from '@/config/i18n'

const transformPeriodToRange = (
  period: PeriodValues,
  range?: CalendarRange
): CalendarRange => {
  const now = new Date()
  switch (period) {
    case PERIOD_MAP.DAILY:
      return {
        startDate: startOfDay(now),
        endDate: now
      }
    case PERIOD_MAP.WEEKLY:
      return {
        startDate: sub(Date.now(), { weeks: 1 }),
        endDate: now
      }
    case PERIOD_MAP['MONTHS-1']:
      return {
        startDate: sub(Date.now(), { months: 1 }),
        endDate: now
      }
    case PERIOD_MAP['MONTHS-3']:
      return {
        startDate: sub(Date.now(), { days: 90 }),
        endDate: now
      }
    case PERIOD_MAP.CUSTOM:
      return {
        startDate: startOfDay(range!.startDate),
        endDate: endOfDay(range!.endDate)
      }
    default:
      return null as never
  }
}
const formatPeriodValue = (period: PeriodValues, range?: CalendarRange) => {
  if (period === PERIOD_MAP.CUSTOM) {
    const { startDate, endDate } = range || {}
    return `${startDate && format(startDate, 'dd MMM')} ― ${
      endDate && format(endDate, 'dd MMM')
    }`
  } else {
    return i18n.t(`performance.range-picker.${period}`)
  }
}
export { formatPeriodValue, transformPeriodToRange }
